import { useNavigate } from "react-router-dom";
import ModalTitleButton from "../Dashboard/SubDashboard/ModalTitleButton/ModalTitleButton";

function BrandLogOutBox({ closeModal }) {
  const navigation = useNavigate();

  const chooseAction = () => {
    try {
      localStorage.removeItem("token");
    } catch {
      // ignore
    }
    navigation("/login");
  };

  return (
    <>
      <div className="fixed top-0 left-0 w-screen h-screen bg-black opacity-40"></div>
      <div className="fixed top-1/4 left-1/4 w-2/5 bg-white rounded-lg shadow pb-10">
        <ModalTitleButton
          text="خروج"
          closeModal={closeModal}
          chooseAction={chooseAction}
        >
          <div className="flex flex-col justify-evenly">
            <div className="flex flex-row-reverse items-center justify-center my-10">
              <img
                src="/image/icon/logOutWhite.png"
                alt="Logout"
                className="w-14 ml-4 bg-slate-700 rounded-full p-2"
              />
              <div className="flex flex-col text-center">
                <p className="t-purpleDark text-lg">
                  آیا جهت خروج از پنل مدیریت برند اطمینان دارید؟
                </p>
                <p className="text-sm text-slate-400 mt-2">
                  خروج از پنل مدیریت برند
                </p>
              </div>
            </div>
          </div>
        </ModalTitleButton>
      </div>
    </>
  );
}

export default BrandLogOutBox;

